import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import img2 from '../../../assets/images/home_page_4/product/02.png'
import img3 from '../../../assets/images/home_page_4/product/05.png'
import img4 from "../../../assets/images/home_page_4/product/04.png";
import img6 from "../../../assets/images/home_page_4/product/06.png";
import img7 from "../../../assets/images/home_page_4/product/07.png";
import img8 from "../../../assets/images/home_page_4/product/08.png";
import img11 from "../../../assets/images/home_page_4/product/11.png";

const testSlider = {
    slidesToShow: 1,
    infinite: true,
    dots: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
};

const product = [
    {
        id: 1,
        img: img4,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
    {
        id: 2,
        img: img2,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
    {
        id: 3,
        img: img3,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
    {
        id: 4,
        img: img4,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
    {
        id: 5,
        img: img11,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
];


const products = [
    {
        id: 1,
        img: img4,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
    {
        id: 2,
        img: img6,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
    {
        id: 3,
        img: img7,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
    {
        id: 4,
        img: img8,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
    {
        id: 5,
        img: img11,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
];

const HomeProductOne = () => {
    return (
        <div>
            <section id="home-product-one" className="home-product-one-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="home-product-block text-center">
                                        <div className="advertise-block text-start">
                                            <h6 className="advertise-sub-heading">Weekend Discount</h6>
                                            <h2 className="advertise-heading">New Device coming this fall</h2>
                                            <p>Big screens in incredibly slim designs...</p>
                                        </div>
                                        <Slider className="slider home-product-one-autoplay" {...testSlider}>
                                            {product.map(product => (
                                                <div key={product.id} className="home-product-one-img-dtl">
                                                    <div className="home-product-img">
                                                        <Link to="/ShopDetails" title="">
                                                            <img src={product.img} className="img-fluid" alt={product.title} />
                                                        </Link>
                                                    </div>
                                                    <div className="home-product-dtls text-start">
                                                        <ul>
                                                            <li className="icons"><i className="flaticon-star"></i></li>
                                                            <li className="icons"><i className="flaticon-star"></i></li>
                                                            <li className="icons"><i className="flaticon-star"></i></li>
                                                            <li className="icons"><i className="flaticon-star"></i></li>
                                                            <li className="icons"><i className="flaticon-star"></i></li>
                                                            <li className="total-rating">(3)</li>
                                                        </ul>
                                                        <h4 className="home-product-heading">
                                                            <Link to="/ShopDetails" title="">{product.title}</Link>
                                                        </h4>
                                                        <div className="product-price-cart-block">
                                                            <div className="row">
                                                                <div className="col-lg-6 col-6">
                                                                    <div className="home-product-price">
                                                                        {product.price}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6 col-6">
                                                                    <div className="home-product-cart">
                                                                        <Link to="/ShopDetails" title="">
                                                                            <i className="flaticon-shopping-cart"></i>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="progress-block">
                                                            <progress className="progress-bar" value="60" max="100"></progress>
                                                            <div className="row">
                                                                <div className="col-lg-6 col-6">
                                                                    <div className="product-avail">Available: <b>{product.available}</b></div>
                                                                </div>
                                                                <div className="col-lg-6 col-6">
                                                                    <div className="product-sold">Sold: <b>{product.sold}</b></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p>Time remaining until the end of the offer.</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="home-product-block text-center">
                                        <div className="advertise-block text-start">
                                            <h6 className="advertise-sub-heading">Weekend Discount</h6>
                                            <h2 className="advertise-heading">New Device coming this fall</h2>
                                            <p>Big screens in incredibly slim designs...</p>
                                        </div>
                                        <Slider className="slider home-product-one-autoplay" {...testSlider}>
                                            {products.map(product => (
                                                <div key={product.id} className="home-product-one-img-dtl">
                                                    <div className="home-product-img">
                                                        <Link to="/ShopDetails" title="">
                                                            <img src={product.img} className="img-fluid" alt={product.title} />
                                                        </Link>
                                                    </div>
                                                    <div className="home-product-dtls text-start">
                                                        <ul>
                                                            <li className="icons"><i className="flaticon-star"></i></li>
                                                            <li className="icons"><i className="flaticon-star"></i></li>
                                                            <li className="icons"><i className="flaticon-star"></i></li>
                                                            <li className="icons"><i className="flaticon-star"></i></li>
                                                            <li className="icons"><i className="flaticon-star"></i></li>
                                                            <li className="total-rating">(3)</li>
                                                        </ul>
                                                        <h4 className="home-product-heading">
                                                            <Link to="/ShopDetails" title="">{product.title}</Link>
                                                        </h4>
                                                        <div className="product-price-cart-block">
                                                            <div className="row">
                                                                <div className="col-lg-6 col-6">
                                                                    <div className="home-product-price">
                                                                        {product.price}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6 col-6">
                                                                    <div className="home-product-cart">
                                                                        <Link to="/ShopDetails" title="">
                                                                            <i className="flaticon-shopping-cart"></i>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="progress-block">
                                                            <progress className="progress-bar" value="60" max="100"></progress>
                                                            <div className="row">
                                                                <div className="col-lg-6 col-6">
                                                                    <div className="product-avail">Available: <b>{product.available}</b></div>
                                                                </div>
                                                                <div className="col-lg-6 col-6">
                                                                    <div className="product-sold">Sold: <b>{product.sold}</b></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p>Time remaining until the end of the offer.</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="home-product-one-sidebar-block">
                                <div className="row">
                                    <div className="col-lg-4 col-5">
                                        <div className="home-product-one-sidebar-img">
                                            <Link to="/ShopDetails" title="">
                                                <img
                                                    src={img7}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-7">
                                        <div className="home-product-one-sidebar-dtl home-product-dtls">
                                            <ul>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="total-rating">(3)</li>
                                            </ul>
                                            <div className="deals-product-dtls">
                                                <h4 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h4>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="home-product-one-sidebar-block">
                                <div className="row">
                                    <div className="col-lg-4 col-5">
                                        <div className="home-product-one-sidebar-img">
                                            <Link to="/ShopDetails" title="">
                                                <img
                                                    src={img8}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-7">
                                        <div className="home-product-one-sidebar-dtl home-product-dtls">
                                            <ul>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="total-rating">(3)</li>
                                            </ul>
                                            <div className="deals-product-dtls">
                                                <h4 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h4>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="home-product-one-sidebar-block">
                                <div className="row">
                                    <div className="col-lg-4 col-5">
                                        <div className="home-product-one-sidebar-img">
                                            <Link to="/ShopDetails" title="">
                                                <img
                                                    src={img7}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-7">
                                        <div className="home-product-one-sidebar-dtl home-product-dtls">
                                            <ul>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="total-rating">(3)</li>
                                            </ul>
                                            <div className="deals-product-dtls">
                                                <h4 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h4>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="home-product-one-sidebar-block">
                                <div className="row">
                                    <div className="col-lg-4 col-5">
                                        <div className="home-product-one-sidebar-img">
                                            <Link to="/ShopDetails" title="">
                                                <img
                                                    src={img11}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-7">
                                        <div className="home-product-one-sidebar-dtl home-product-dtls">
                                            <ul>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="icons">
                                                    <i className="flaticon-star" />
                                                </li>
                                                <li className="total-rating">(3)</li>
                                            </ul>
                                            <div className="deals-product-dtls">
                                                <h4 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h4>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
}

export default HomeProductOne;